import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { Spinner } from "@/components/ui/spinner";
import { getCurrentFacility } from "modules/facility/facilitySelectors";

/**
 * Setup and the Image Library need the facility's Ad Spaces entitlement. The
 * dashboard disables their buttons; this keeps a typed or bookmarked URL out
 * too. Same rule as the buttons: only an explicit `canUseAdKit: false` is
 * refused. Waits while the facility is still loading rather than mounting.
 */
export function AdSpacesRouteGuard() {
  const facility = useSelector(getCurrentFacility);

  if (!facility) {
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <Spinner className="size-6 text-text-muted" />
      </div>
    );
  }

  if (facility.capabilities?.canUseAdKit === false) {
    return <Navigate to="/ad-spaces" replace />;
  }

  return <Outlet />;
}
